import { render, staticRenderFns } from "./RecordPrivacy.vue?vue&type=template&id=c35ef9a6&scoped=true"
import script from "./RecordPrivacy.vue?vue&type=script&lang=js"
export * from "./RecordPrivacy.vue?vue&type=script&lang=js"
import style0 from "./RecordPrivacy.vue?vue&type=style&index=0&id=c35ef9a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ef9a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
